import type { ImageModel, ImageModelFR } from './ImageModel';
import { translateImageModel } from './ImageModel';
import type { TeamMemberModel, TeamMemberModelFR } from './TeamMemberModel';
import { translateTeamMemberArray } from './TeamMemberModel';
import type { TypeVideoEmbedEnum } from './enums/TypeVideoEmbedEnum';

export type ProjectManagerFR = {
  id: number;
  nom: string;
  descriptionLongue: string;
  engagementsRSE: string;
  typeGestionnaire: string;
  profilsProjets: string;
  secteurGeo: string;
  typeVideoEmbed: TypeVideoEmbedEnum;
  idVideoEmbed: string;
  logo: ImageModelFR;
  urlSiteSociete: string;
  chiffresClesLibelle1: string;
  chiffresClesValeur1: string;
  chiffresClesLibelle2: string;
  chiffresClesValeur2: string;
  chiffresClesLibelle3: string;
  chiffresClesValeur3: string;
  chiffresClesLibelle4: string;
  chiffresClesValeur4: string;
  chiffresClesLibelle5: string;
  chiffresClesValeur5: string;
  nbProjetsFinances: number;
  montantLeveSurWiseed: number;
  rendementMoyen: number;
  membresEquipe: TeamMemberModelFR[];
};

export type ProjectManager = {
  id: number;
  nom: string;
  descriptionLongue: string;
  engagementsRSE: string;
  typeGestionnaire: string;
  profilsProjets: string;
  secteurGeo: string;
  typeVideoEmbed: TypeVideoEmbedEnum;
  idVideoEmbed: string;
  logo: ImageModel;
  urlSiteSociete: string;
  chiffresClesLibelle1: string;
  chiffresClesValeur1: string;
  chiffresClesLibelle2: string;
  chiffresClesValeur2: string;
  chiffresClesLibelle3: string;
  chiffresClesValeur3: string;
  chiffresClesLibelle4: string;
  chiffresClesValeur4: string;
  chiffresClesLibelle5: string;
  chiffresClesValeur5: string;
  nbProjetsFinances: number;
  montantLeveSurWiseed: number;
  rendementMoyen: number;
  teamMembers: TeamMemberModel[];
};

export const translateProjectManger = (pm: ProjectManagerFR): ProjectManager => {
  return {
    id: pm.id,
    nom: pm.nom,
    descriptionLongue: pm.descriptionLongue,
    engagementsRSE: pm.engagementsRSE,
    typeGestionnaire: pm.typeGestionnaire,
    profilsProjets: pm.profilsProjets,
    secteurGeo: pm.secteurGeo,
    typeVideoEmbed: pm.typeVideoEmbed,
    idVideoEmbed: pm.idVideoEmbed,
    logo: pm.logo && translateImageModel(pm.logo),
    urlSiteSociete: pm.urlSiteSociete,
    chiffresClesLibelle1: pm.chiffresClesLibelle1,
    chiffresClesValeur1: pm.chiffresClesValeur1,
    chiffresClesLibelle2: pm.chiffresClesLibelle2,
    chiffresClesValeur2: pm.chiffresClesValeur2,
    chiffresClesLibelle3: pm.chiffresClesLibelle3,
    chiffresClesValeur3: pm.chiffresClesValeur3,
    chiffresClesLibelle4: pm.chiffresClesLibelle4,
    chiffresClesValeur4: pm.chiffresClesValeur4,
    chiffresClesLibelle5: pm.chiffresClesLibelle5,
    chiffresClesValeur5: pm.chiffresClesValeur5,
    nbProjetsFinances: pm.nbProjetsFinances,
    montantLeveSurWiseed: pm.montantLeveSurWiseed,
    rendementMoyen: pm.rendementMoyen,
    teamMembers: pm.membresEquipe && translateTeamMemberArray(pm.membresEquipe),
  };
};
